import * as _ from "lodash";
import * as FuturesContractActions from "features/futuresContracts/futuresContracts.actions";
import { useDispatch } from "react-redux";
import useUniqueId from "common/ui/useUniqueId";
import { useEffect, useRef } from "react";


export default function useContractsSubscription(symbols: string[]) {
    const dispatch = useDispatch();
    const id = useUniqueId();
    const subscribedSymbols = useRef<string[]>([]);
    
    const uniqueSymbols = _.uniq(symbols?.filter(m => m != null) ?? []);
    
    useEffect(() => {
        if (_.xor(uniqueSymbols, subscribedSymbols.current).length > 0) {
            subscribedSymbols.current = uniqueSymbols;
            FuturesContractActions.subscribeToContracts(id, subscribedSymbols.current)(dispatch);
        }
    }, [symbols])

    return () => {
        FuturesContractActions.unsubscribeFromContracts(id)(dispatch);
    }
}